import { StyledCard as BaseStyledCard } from "../../OSMDataAdmin/styled";

export const StyledCard = BaseStyledCard;
